// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VisitRouteImport } from './routes/visit'
import { Route as SogRouteImport } from './routes/sog'
import { Route as ShowroomRouteImport } from './routes/showroom'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnskelisteRouteImport } from './routes/onskeliste'
import { Route as MuranoRouteImport } from './routes/murano'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EnRouteImport } from './routes/en'
import { Route as AlleRouteImport } from './routes/alle'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StorrelseIndexRouteImport } from './routes/storrelse.index'
import { Route as FarverIndexRouteImport } from './routes/farver.index'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as StorrelseRangeRouteImport } from './routes/storrelse.$range'
import { Route as ProductsHandleRouteImport } from './routes/products.$handle'
import { Route as FarverSlugRouteImport } from './routes/farver.$slug'
import { Route as CollectionsHandleRouteImport } from './routes/collections.$handle'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as MuranoMatchRouteImport } from './routes/murano.match'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as EnVisitRouteImport } from './routes/en.visit'
import { Route as EnSogRouteImport } from './routes/en.sog'
import { Route as EnShowroomRouteImport } from './routes/en.showroom'
import { Route as EnPrivacyRouteImport } from './routes/en.privacy'
import { Route as EnOnskelisteRouteImport } from './routes/en.onskeliste'
import { Route as EnMuranoRouteImport } from './routes/en.murano'
import { Route as EnFaqRouteImport } from './routes/en.faq'
import { Route as EnAlleRouteImport } from './routes/en.alle'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as BlogSlugPostRouteImport } from './routes/blog.$slug_.$post'
import { Route as MuranoLeksikonIndexRouteImport } from './routes/murano.leksikon.index'
import { Route as MuranoLeksikonSlugRouteImport } from './routes/murano.leksikon.$slug'
import { Route as EnStorrelseIndexRouteImport } from './routes/en.storrelse.index'
import { Route as EnFarverIndexRouteImport } from './routes/en.farver.index'
import { Route as EnCollectionsIndexRouteImport } from './routes/en.collections.index'
import { Route as EnBlogIndexRouteImport } from './routes/en.blog.index'
import { Route as EnStorrelseRangeRouteImport } from './routes/en.storrelse.$range'
import { Route as EnProductsHandleRouteImport } from './routes/en.products.$handle'
import { Route as EnFarverSlugRouteImport } from './routes/en.farver.$slug'
import { Route as EnCollectionsHandleRouteImport } from './routes/en.collections.$handle'
import { Route as EnBlogSlugRouteImport } from './routes/en.blog.$slug'
import { Route as EnMuranoMatchRouteImport } from './routes/en.murano.match'
import { Route as EnBlogSlugPostRouteImport } from './routes/en.blog.$slug_.$post'
import { Route as EnMuranoLeksikonIndexRouteImport } from './routes/en.murano.leksikon.index'
import { Route as EnMuranoLeksikonSlugRouteImport } from './routes/en.murano.leksikon.$slug'

const VisitRoute = VisitRouteImport.update({
            id: '/visit',path: '/visit',getParentRoute: () => rootRouteImport
          })
const SogRoute = SogRouteImport.update({
            id: '/sog',path: '/sog',getParentRoute: () => rootRouteImport
          })
const ShowroomRoute = ShowroomRouteImport.update({
            id: '/showroom',path: '/showroom',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OnskelisteRoute = OnskelisteRouteImport.update({
            id: '/onskeliste',path: '/onskeliste',getParentRoute: () => rootRouteImport
          })
const MuranoRoute = MuranoRouteImport.update({
            id: '/murano',path: '/murano',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EnRoute = EnRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const AlleRoute = AlleRouteImport.update({
            id: '/alle',path: '/alle',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StorrelseIndexRoute = StorrelseIndexRouteImport.update({
            id: '/storrelse/',path: '/storrelse/',getParentRoute: () => rootRouteImport
          })
const FarverIndexRoute = FarverIndexRouteImport.update({
            id: '/farver/',path: '/farver/',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const StorrelseRangeRoute = StorrelseRangeRouteImport.update({
            id: '/storrelse/$range',path: '/storrelse/$range',getParentRoute: () => rootRouteImport
          })
const ProductsHandleRoute = ProductsHandleRouteImport.update({
            id: '/products/$handle',path: '/products/$handle',getParentRoute: () => rootRouteImport
          })
const FarverSlugRoute = FarverSlugRouteImport.update({
            id: '/farver/$slug',path: '/farver/$slug',getParentRoute: () => rootRouteImport
          })
const CollectionsHandleRoute = CollectionsHandleRouteImport.update({
            id: '/collections/$handle',path: '/collections/$handle',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const MuranoMatchRoute = MuranoMatchRouteImport.update({
            id: '/match',path: '/match',getParentRoute: () => MuranoRoute
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnRoute
          })
const EnVisitRoute = EnVisitRouteImport.update({
            id: '/visit',path: '/visit',getParentRoute: () => EnRoute
          })
const EnSogRoute = EnSogRouteImport.update({
            id: '/sog',path: '/sog',getParentRoute: () => EnRoute
          })
const EnShowroomRoute = EnShowroomRouteImport.update({
            id: '/showroom',path: '/showroom',getParentRoute: () => EnRoute
          })
const EnPrivacyRoute = EnPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => EnRoute
          })
const EnOnskelisteRoute = EnOnskelisteRouteImport.update({
            id: '/onskeliste',path: '/onskeliste',getParentRoute: () => EnRoute
          })
const EnMuranoRoute = EnMuranoRouteImport.update({
            id: '/murano',path: '/murano',getParentRoute: () => EnRoute
          })
const EnFaqRoute = EnFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => EnRoute
          })
const EnAlleRoute = EnAlleRouteImport.update({
            id: '/alle',path: '/alle',getParentRoute: () => EnRoute
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => EnRoute
          })
const BlogSlugPostRoute = BlogSlugPostRouteImport.update({
            id: '/blog/$slug_/$post',path: '/blog/$slug/$post',getParentRoute: () => rootRouteImport
          })
const MuranoLeksikonIndexRoute = MuranoLeksikonIndexRouteImport.update({
            id: '/leksikon/',path: '/leksikon/',getParentRoute: () => MuranoRoute
          })
const MuranoLeksikonSlugRoute = MuranoLeksikonSlugRouteImport.update({
            id: '/leksikon/$slug',path: '/leksikon/$slug',getParentRoute: () => MuranoRoute
          })
const EnStorrelseIndexRoute = EnStorrelseIndexRouteImport.update({
            id: '/storrelse/',path: '/storrelse/',getParentRoute: () => EnRoute
          })
const EnFarverIndexRoute = EnFarverIndexRouteImport.update({
            id: '/farver/',path: '/farver/',getParentRoute: () => EnRoute
          })
const EnCollectionsIndexRoute = EnCollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => EnRoute
          })
const EnBlogIndexRoute = EnBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => EnRoute
          })
const EnStorrelseRangeRoute = EnStorrelseRangeRouteImport.update({
            id: '/storrelse/$range',path: '/storrelse/$range',getParentRoute: () => EnRoute
          })
const EnProductsHandleRoute = EnProductsHandleRouteImport.update({
            id: '/products/$handle',path: '/products/$handle',getParentRoute: () => EnRoute
          })
const EnFarverSlugRoute = EnFarverSlugRouteImport.update({
            id: '/farver/$slug',path: '/farver/$slug',getParentRoute: () => EnRoute
          })
const EnCollectionsHandleRoute = EnCollectionsHandleRouteImport.update({
            id: '/collections/$handle',path: '/collections/$handle',getParentRoute: () => EnRoute
          })
const EnBlogSlugRoute = EnBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => EnRoute
          })
const EnMuranoMatchRoute = EnMuranoMatchRouteImport.update({
            id: '/match',path: '/match',getParentRoute: () => EnMuranoRoute
          })
const EnBlogSlugPostRoute = EnBlogSlugPostRouteImport.update({
            id: '/blog/$slug_/$post',path: '/blog/$slug/$post',getParentRoute: () => EnRoute
          })
const EnMuranoLeksikonIndexRoute = EnMuranoLeksikonIndexRouteImport.update({
            id: '/leksikon/',path: '/leksikon/',getParentRoute: () => EnMuranoRoute
          })
const EnMuranoLeksikonSlugRoute = EnMuranoLeksikonSlugRouteImport.update({
            id: '/leksikon/$slug',path: '/leksikon/$slug',getParentRoute: () => EnMuranoRoute
          })





const EnMuranoRouteChildren = {
  EnMuranoMatchRoute: EnMuranoMatchRoute,EnMuranoLeksikonSlugRoute: EnMuranoLeksikonSlugRoute,EnMuranoLeksikonIndexRoute: EnMuranoLeksikonIndexRoute
}

const EnMuranoRouteWithChildren = EnMuranoRoute._addFileChildren(EnMuranoRouteChildren)



const EnRouteChildren = {
  EnAboutRoute: EnAboutRoute,EnAlleRoute: EnAlleRoute,EnFaqRoute: EnFaqRoute,EnMuranoRoute: EnMuranoRouteWithChildren,EnOnskelisteRoute: EnOnskelisteRoute,EnPrivacyRoute: EnPrivacyRoute,EnShowroomRoute: EnShowroomRoute,EnSogRoute: EnSogRoute,EnVisitRoute: EnVisitRoute,EnIndexRoute: EnIndexRoute,EnBlogSlugRoute: EnBlogSlugRoute,EnCollectionsHandleRoute: EnCollectionsHandleRoute,EnFarverSlugRoute: EnFarverSlugRoute,EnProductsHandleRoute: EnProductsHandleRoute,EnStorrelseRangeRoute: EnStorrelseRangeRoute,EnBlogIndexRoute: EnBlogIndexRoute,EnCollectionsIndexRoute: EnCollectionsIndexRoute,EnFarverIndexRoute: EnFarverIndexRoute,EnStorrelseIndexRoute: EnStorrelseIndexRoute,EnBlogSlugPostRoute: EnBlogSlugPostRoute
}

const EnRouteWithChildren = EnRoute._addFileChildren(EnRouteChildren)




const MuranoRouteChildren = {
  MuranoMatchRoute: MuranoMatchRoute,MuranoLeksikonSlugRoute: MuranoLeksikonSlugRoute,MuranoLeksikonIndexRoute: MuranoLeksikonIndexRoute
}

const MuranoRouteWithChildren = MuranoRoute._addFileChildren(MuranoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AlleRoute: AlleRoute,EnRoute: EnRouteWithChildren,FaqRoute: FaqRoute,MuranoRoute: MuranoRouteWithChildren,OnskelisteRoute: OnskelisteRoute,PrivacyRoute: PrivacyRoute,ShowroomRoute: ShowroomRoute,SogRoute: SogRoute,VisitRoute: VisitRoute,BlogSlugRoute: BlogSlugRoute,CollectionsHandleRoute: CollectionsHandleRoute,FarverSlugRoute: FarverSlugRoute,ProductsHandleRoute: ProductsHandleRoute,StorrelseRangeRoute: StorrelseRangeRoute,BlogIndexRoute: BlogIndexRoute,CollectionsIndexRoute: CollectionsIndexRoute,FarverIndexRoute: FarverIndexRoute,StorrelseIndexRoute: StorrelseIndexRoute,BlogSlugPostRoute: BlogSlugPostRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)